
  import Vue from 'vue'
  import ReadingService from '@/services/ReadingService';
import { extractErrorMessage } from '@/utils/Util';

  export default Vue.extend({
    name: 'ReadingRestoreDialog',

    props: ['reading'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmRestore() {
        this.loading = true;
      
        ReadingService.restoreReading(this.$root.$store.state.session.selectedTenant.uuid, this.reading.uuid).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('reading.successRestore') as string;
            this.alertVisible = true;
            this.loading = false;
            
            setTimeout(() => { 
                this.$emit("restore", this.reading);
                this.dismiss(); 
            }, 2000);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('reading.errorRestore') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      }
    }
  })
